import { Box, Chip, Typography } from '@mui/material';
import { ImageField, useTranslate } from 'react-admin';
import { NoImage } from '@/components/global/fields/NoImage';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledMarketingCampaignField = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    '& .campaign-image': {
        width: '54px',
        height: '54px',
        '& .RaImageField-image': {
            width: '54px',
            height: '54px',
            objectFit: 'cover',
            borderRadius: '4px',
        },
    },
    '& .MuiTypography-root.MuiTypography-body1': {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22px',
        letterSpacing: '-0.16px',
        marginBottom: '4px',
    },
});

export const MarketingCampaignField = ({ record }) => {
    const translate = useTranslate();
    if (!record) return null;

    return (
        <StyledMarketingCampaignField>
            {record.image ? (
                <ImageField className='campaign-image' source='image' record={record} />
            ) : (
                <NoImage sx={{ minWidth: '54px', minHeight: '54px', width: '54px', height: '54px' }} />
            )}
            <Box>
                <Typography variant='body1'>{record.name}</Typography>
                {record.sponsored && (
                    <Chip label={translate('resources.campaign.labels.sponsoredLabel')} size='small' style={{ backgroundColor: Palette.violet.violet100 }} />
                )}
            </Box>
        </StyledMarketingCampaignField>
    );
};
